<template>
  <SectionLayout :section-title="sectionTitle" custom-class="p-2" section-key="changelog" :loading="loadingDashboard">
    <template #headerAction>
      <a href="https://feedback.gempages.net/f/changelog/" target="_blank" class="d-flex align-items-center dashboard__link">
        <!-- Read More -->
        <span class="paragraph-14-16-medium dashboard__link-txt">{{ viewMore }}</span>
        <div class=" dashboard__link-icon d-flex align-items-center">
          <i class="icon icon-link"></i>
        </div>
      </a>
    </template>
    <template #default>
      <div class="changelog__body bg-light1 p-2 border-radius clickable" @click="openPreview" v-if="changelog">
        <p class="text-light-high heading-h5-16-medium">{{ changelog.title }}</p>
        <div class="d-flex align-items-center mt-1" v-if="tags.length != 0">
          <span v-for="tag in tags" class="text-uppercase body-10-medium border-radius changelog__tag" :class="tag" :key="tag">{{ tag }}</span>
        </div>
        <p class="text-light-high paragraph-14-regular mt-2">{{ changelog.date }}</p>
        <div class="changelog__list mt-1" v-if="logList.length">
          <div v-for="(changelogItem, index) in logList" class="changelog__item" :key="index">{{ changelogItem }}</div>
        </div>
      </div>
      <div class="bg-light1 p-2 border-radius clickable" v-if="loadingDashboard">
        <div class="mb-1 changelog__loading long skeleton-light-grey-200"></div>
        <div class="mb-1 changelog__loading skeleton-light-grey-200"></div>
        <div class="mb-1 changelog__loading skeleton-light-grey-200"></div>
        <div class="mb-1 changelog__loading skeleton-light-grey-200"></div>
        <div class="mb-1 changelog__loading skeleton-light-grey-200"></div>
      </div>

      <Modal v-if="showPreview" :active="showPreview" mClass="p-0 changelog__modal-container-body" closeClass="p-1" padding="p-0" @cancel="closePreview" @container="closePreview">
        <template #default>
          <div class="changelog__modal">
            <div class="d-flex justify-content-between align-items-center pb-3 changelog__modal-head p-4">
              <div class="changelog__title typo-h6 text-lightmode">{{ sectionTitle }}</div>
              <div class="gp_modal-close p-1 changelog__close" @click="closePreview"><i class="icon icon-cancel"></i></div>
            </div>
            <div class="bg-light1 border-radius changelog__modal-body p-4 pt-2">
              <div class="d-flex align-items-center mt-1">
                <p class="text-lighmode typo-body1 weight-500 mr-2 text-lightmode">{{ changelog.title }}</p>
                <span v-for="tag in tags" class="text-uppercase body-10-medium border-radius changelog__tag" :class="tag" :key="tag">{{ tag }}</span>
              </div>
              <div class="text-dark6 typo-paragraph14 mt-1 mb-2">{{ changelog.date }}</div>
              <div class="changelog__content" v-html="changelog.content"></div>
            </div>
          </div>
        </template>
      </Modal>
    </template>
  </SectionLayout>
</template>

<script>
import SectionLayout from "./SectionLayout.vue";
import { mapGetters } from "vuex";

export default {
  name: "ChangeLog",
  components: {
    SectionLayout
  },
  data: () => ({
    showPreview: false
  }),
  computed: {
    ...mapGetters("account", {
      lang: "displayLanguage"
    }),
    ...mapGetters("dashboard", {
      allChangeLog: "changelog",
      loadingDashboard: "loading"
    }),
    sectionTitle() {
      return this.$t("dashboard.changelog");
    },
    viewMore() {
      return this.$t("dashboard.viewMore");
    },
    changelog() {
      if (this.allChangeLog.length) {
        const data = this.allChangeLog[0];
        const lang = this.lang;
        const defaultLang = "en";
        const result = {
          title: !data.title[lang] ? data.title[defaultLang] : data.title[lang],
          date: !data.date[lang] ? data.date[defaultLang] : data.date[lang],
          tags: !data.tags[lang] ? data.tags[defaultLang] : data.tags[lang],
          content: !data.content[lang] ? data.content[defaultLang] : data.content[lang]
        };

        return result;
      } else {
        return false;
      }
    },
    tags() {
      const tagList = this.changelog.tags;
      if(tagList.length == 0) return tagList; 
      return this.changelog.tags.split(",");
    },
    logList() {
      const container = document.createElement("div");
      container.innerHTML = this.changelog.content;
      const headings = container.querySelectorAll("h3, h4");
      const headingTexts = [];
      for (let i = 0; i < headings.length; i++) {
        if (i < 4) {
          headingTexts.push(headings[i].innerText);
        }
        if (i == 4) {
          headingTexts.push("...");
        }
      }
      return headingTexts;
    }
  },
  methods: {
    closePreview() {
      this.showPreview = false;
    },
    openPreview() {
      this.showPreview = true;
    }
  }
};
</script>

<style lang="scss">
.changelog__modal {
  background-color: #fff;
  border-radius: 3px;
  &-container-body {
    overflow: unset !important;
  }
  .changelog__modal-head {
    border-bottom: 1px solid $textDarkModeHigh;
  }
  .changelog__modal-body {
    max-height: calc(100vh - 160px - 91px);
    overflow-y: auto;
    &::-webkit-scrollbar-thumb {
      background: transparent;
    }
    &:hover {
      &::-webkit-scrollbar-thumb {
        background: rgba($textLightModeDisabled, 0.5);
        &:hover {
          background: rgba($textLightModeDisabled, 1);
        }
      }
    }
  }
}

.changelog {
  &__title {
    font-size: 20px;
    line-height: 24px;
    font-style: normal;
    letter-spacing: 0px;
    text-align: left;
  }

  &__body {
    border: solid 1px $light3;
    &:hover {
      @include border-hover;
    }
  }

  &__loading {
    height: 16px;
  }

  &__close {
    &.gp_modal-close {
      position: relative;
      top: 0;
      left: 0;
    }
  }

  &__tag {
    padding: 3px 6px;
    margin-left: 6px;
    font-size: 12px;
    line-height: 14px;
    &:first-child {
      margin-left: 0;
    }

    &.new {
      color: #fff;
      border: 1px solid $accent-green1;
      background-color: $accent-green1;
    }
    &.fixed {
      color: #fff;
      border: 1px solid $accent-yellow;
      background-color: $accent-yellow;
    }
    &.improved {
      color: #fff;
      border: 1px solid $accent-cyan1;
      background-color: $accent-cyan1;
    }
  }

  &__modal {
    width: 640px;
  }

  &__list {
    

    .changelog__item {
      display: block;
      color: $dark6;
      font-size: 14px;
      line-height: 21px;
      font-weight: 400;
      position: relative;
      margin-left: 16px;

      &:before {
        position: absolute;
        content: " ";
        width: 4px;
        height: 4px;
        background-color: $shade5;
        border-radius: 50%;
        top: 9px;
        left: -11px;
      }
    }
    
  }

  &__content {
    
    color: $textLightModeHigh;
    font-size: 14px;
    line-height: 1.5;

    h1, h2, h3, h4{
      margin-top: 24px;
      margin-bottom: 8px;
    }
    h1, h2 {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
    }
    h3, h4 {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
    }
    p {
      font-size: 14px;
      line-height: 1.5;
      margin: 8px 0;
    }
  
    

    ul {
      padding-left: 40px;
    }

    .badge {
      border-radius: $radius;
      padding: 3px 6px;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.01em;
      font-weight: 500;
      z-index: 2;
      position: relative;
      text-transform: uppercase;
    }

    .badge-group {
      position: relative;
      margin: 8px 0;
      display: flex;
      align-items: center;
      .space {
        width: 8px;
        position: relative;
        z-index: 2;
        background-color: #fff;
        height: 2px;
      }
      .hr {
        &:after {
          position: absolute;
          content: " ";
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 1px;
          width: 100%;
          background-color: $textDarkModeHigh;
        }
      }
    }
    .bg {
      &--new {
        color: #fff;
        border: 1px solid $accent-green1;
        background-color: $accent-green1;
      }
      &--fixed {
        color: #fff;
        border: 1px solid $accent-yellow;
        background-color: $accent-yellow;
      }
      &--improved {
        color: #fff;
        border: 1px solid $accent-cyan1;
        background-color: $accent-cyan1;
      }
    }

    figure{
      margin: 24px 0;
    }
    img {
      max-width: 100%;
    }
  }
}
</style>
